import { render } from "./TrattativePreview.vue?vue&type=template&id=ad9bb660&scoped=true"
import script from "./TrattativePreview.vue?vue&type=script&lang=js"
export * from "./TrattativePreview.vue?vue&type=script&lang=js"

import "./TrattativePreview.vue?vue&type=style&index=0&id=ad9bb660&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad9bb660"]])

export default __exports__